import berserk from './img/berserk.jpg'
import chainsawman from './img/chainsawman.jpg'
import chicken_little from './img/chicken_little.jpg'
import Crack from './img/CRACKING_ANIMATION.jpg'
import Demon_in_the_wood from './img/Demon_in_the_wood.jpg'
import Disney_Frozen from './img/Disney_Frozen.jpg'
import Hayao_Miyazak from './img/Hayao_Miyazaki.jpeg'
import kaiju from './img/kaiju.jpg'
import miyazaki_world from './img/miyazaki_world.jpg'
import one_punch_man from './img/one_punch_man.jpg'
import Scoob from './img/SCOOB.jpg'
import Sleeping_beauty from './img/Sleeping_beauty.jpg'
import the_art_of_nausicaa from './img/the_art_of_nausicaa.jpg'
import the_lion_king from './img/the_lion_king.jpg'
import mapmakers from './img/THE_MAPMAKERS.jpg'
import web from './img/web.jpeg'
import yona_of_the_dawn from './img/yona_of_the_dawn.jpg'
import yuyu_yakusho from './img/yuyu_yakusho.jpg'
import naruto from './img/naruto.jpg'
import bleach from './img/bleach.jpg'

export const ABookItems = [
  {
    id:701,
    title:"Berserk",
    image: berserk,
    price:2699,
    
  },
  {
    id:702,
    title:"Chainsawman",
    image: chainsawman,
    price:329,
    
  },
  {
    id:703,
    title:"Chicken Little",
    image: chicken_little,
    price:549,
    
  },
  {
    id:704,
    title:"Cracking Animation",
    image: Crack,
    price:1329,
    
  },
  {
    id:705,
    title:"Demon in the Wood",
    image: Demon_in_the_wood,
    price:729,
    
  },
  {
    id:706,
    title:"Frozen",
    image: Disney_Frozen,
    price:499,
    
  },
  {
    id:707,
    title:"Hayao Miyazaki",
    image: Hayao_Miyazak,
    price:3999,
    
  },
  {
    id:708,
    title:"Kaiju",
    image: kaiju,
    price:1679,
    
  },
  {
    id:709,
    title:"Miyazaki World",
    image: miyazaki_world,
    price:1669,
    
  },
  {
    id:710,
    title:"Naruto",
    image: naruto,
    price:15999,
    
  },
  {
    id:711,
    title:"One Punch Man",
    image: one_punch_man,
    price:399,
    
  },
  {
    id:712,
    title:"Scoob!",
    image: Scoob,
    price:4399,
    
  },
  {
    id:713,
    price:879,
    title: "Sleeping Beauty",
    image: Sleeping_beauty,
    
  },
  {
    id:714,
    price:5359,
    title: "The Art Of Nausicaa",
    image: the_art_of_nausicaa,
   
  },
  {id:715,
    price:469,
    title: "The Lion King",
    image: the_lion_king,
    
  },
  {
    id:716,
    price:1299,
    title: "The Mapmakers",
    image: mapmakers,
    
  },
  {
    id:717,
    price:299,
    title: "Charlotte's Web",
    image: web,
    
  },
  {
    id:718,
    price:699,
    title: "Yona of the Dawn",
    image: yona_of_the_dawn,
    
  },
  {
    id:719,
    price:669,
    title: "Yuyu Hakusho",
    image: yuyu_yakusho,
    
  },
  {
    id:720,
    price:10999,
    title: "Bleach",
    image: bleach,
    
  },
  
];